import adminReducer from "@/components/tasks/admin/ducks/reducer"
import userReducer from "@/components/tasks/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const tasksReducer = combineReducers({
  admin: adminReducer,
  user: userReducer,
})

export default tasksReducer
